import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/ci.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm ci

aliases: clean-install, ic, install-clean, isntall-clean
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/ci.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command is similar to `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-install"
      }}><inlineCode parentName="a">{`npm install`}</inlineCode></a>{`, except
it's meant to be used in automated environments such as test platforms,
continuous integration, and deployment -- or any situation where you want
to make sure you're doing a clean install of your dependencies.`}</p>
    <p>{`The main differences between using `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{` are:`}</p>
    <ul>
      <li parentName="ul">{`The project `}<strong parentName="li">{`must`}</strong>{` have an existing `}<inlineCode parentName="li">{`package-lock.json`}</inlineCode>{` or
`}<inlineCode parentName="li">{`npm-shrinkwrap.json`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`If dependencies in the package lock do not match those in `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`,
`}<inlineCode parentName="li">{`npm ci`}</inlineCode>{` will exit with an error, instead of updating the package lock.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`npm ci`}</inlineCode>{` can only install entire projects at a time: individual
dependencies cannot be added with this command.`}</li>
      <li parentName="ul">{`If a `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` is already present, it will be automatically removed
before `}<inlineCode parentName="li">{`npm ci`}</inlineCode>{` begins its install.`}</li>
      <li parentName="ul">{`It will never write to `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` or any of the package-locks:
installs are essentially frozen.`}</li>
    </ul>
    <p>{`NOTE: If you create your `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` file by running `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`
with flags that can affect the shape of your dependency tree, such as
`}<inlineCode parentName="p">{`--legacy-peer-deps`}</inlineCode>{` or `}<inlineCode parentName="p">{`--install-links`}</inlineCode>{`, you `}<em parentName="p">{`must`}</em>{` provide the same
flags to `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{` or you are likely to encounter errors. An easy way to do
this is to run, for example,
`}<inlineCode parentName="p">{`npm config set legacy-peer-deps=true --location=project`}</inlineCode>{` and commit the
`}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file to your repo.`}</p>
    <h3>{`Example`}</h3>
    <p>{`Make sure you have a package-lock and an up-to-date install:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ cd ./my/npm/project
$ npm install
added 154 packages in 10s
$ ls | grep package-lock
`}</code></pre>
    <p>{`Run `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{` in that project`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm ci
added 154 packages in 5s
`}</code></pre>
    <p>{`Configure Travis to build using `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# .travis.yml
install:
- npm ci
# keep the npm cache around to speed up installs
cache:
  directories:
  - "$HOME/.npm"
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`audit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When "true" submit audit reports alongside the current npm command to the
default registry and all registries configured for scopes. See the
documentation for `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-audit"
      }}><inlineCode parentName="a">{`npm audit`}</inlineCode></a>{` for details on what is
submitted.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`foreground-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Run all build scripts (ie, `}<inlineCode parentName="p">{`preinstall`}</inlineCode>{`, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, and `}<inlineCode parentName="p">{`postinstall`}</inlineCode>{`)
scripts for installed packages in the foreground process, sharing standard
input, output, and error with the main npm process.`}</p>
    <p>{`Note that this will generally make installs run slower, and be much noisier,
but can be useful for debugging.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`script-shell`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: '/bin/sh' on POSIX systems, 'cmd.exe' on Windows`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`The shell to use for scripts run with the `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm run`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm
init <pkg>`}</inlineCode>{` commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-lock-json"
        }}>{`package-lock.json`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      